export default __webpack_public_path__ + "ubisoft-playtest-profile-creation-banner-mobile.webp";